import { resetUrlParams } from 'common/utils';

export default {
  props: {
    // 筛选列表
    filterList: {
      default: () => [],
      type: Array,
    },
    total: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      langContext: this.$t('featureComponents.CoursesFilters'),
      curIndex: -1, // 选中前四项筛选项 索引
    }
  },
  created() {
    this.init()
    this.changeFilterUrl()
    this.sendUpdateFilter()
  },
  mounted() {
    this.getSpecialParams()
  },
  methods: {
    // 筛选项数据格式化
    getFilterData() {
      this.filterList.forEach((item) => {
        const tempArr = [{
          name: this.langContext.all,
          key: -1,
          value: -1,
          disable: false,
          selected: true,
        }]
        item.value.forEach((item1) => {
          const temp = {
            name: item1.name,
            value: item1.key,
            key: item1.key,
            disable: false,
            selected: false,
          }
          if (item.type === 'difficulty') {
            temp.color = '#222'
          }
          tempArr.push(temp)
        })
        this.filtersData.push({
          filterName: item.name,
          filterType: item.type,
          dataList: tempArr,
        })
      })
    },
    // 从url参数中获取筛选项
    getUrlFilter() {
      const curQurey = this.$route.query
      const tempList = Object.keys(curQurey).map((key) => ({
        type: key,
        value: curQurey[key],
      }))
      return tempList
    },
    // 获取当前选中筛选项
    getSeletedFilter() {
      const filters = this.filtersData.filter((items) => !items.dataList[0].selected).map((item) => {
        const keysList = item.dataList.filter((item1) => item1.selected).map((item2) => item2.key)
        return {
          type: item.filterType,
          keysList,
        }
      })
      return filters
    },
    // 非筛选项参数
    getSpecialParams() {
      const tempList = this.getUrlFilter()
      this.urlSpecialParams = tempList.filter((item) => !this.filtersData.some((item1) => item1.filterType === item.type))
    },
    // 获取筛选参数
    getChangeFilter() {
      const queryList = []
      const list = this.getSeletedFilter()
      list.forEach((item) => {
        queryList.push({
          type: item.type,
          keys: item.keysList,
        })
      })
      return queryList
    },
    // 获取一级索引
    getParentIndex(type) {
      return this.filtersData.findIndex((item) => item.filterType === type)
    },
    // url参数修改状态
    changeFilterUrl() {
      const tempList = this.getUrlFilter()
      const filterParamList = tempList.filter((item) => this.filtersData.some((item1) => item1.filterType === item.type)).filter((item2) => item2.value)
      filterParamList.forEach((item) => {
        const index = this.filtersData.findIndex((filterItem) => filterItem.filterType === item.type)
        const splitArr = item.value.split('_')
        splitArr.forEach((splitItem) => {
          const index1 = this.filtersData[index].dataList.findIndex((item1) => item1.key === +splitItem)
          if (index1 === -1) return
          this.filtersData[index].dataList[index1].selected = true
          this.filtersData[index].dataList[0].selected = false
          if (this.filtersData[index].filterType === 'difficulty') {
            this.changeRateColor(this.filtersData[index].dataList[index1], index1, index)
          }
        })
        // touch端
        if (this.headersList && this.headersList.length) this.changeHeaderList(item.type)
      })
    },
    // 困难类型五角星 颜色
    changeRateColor(item, index, parentIndex, isHover = false) {
      this.filtersData[parentIndex].dataList[index].color = item.selected || isHover ? '#ffaa0a' : '#222'
    },
    // emit 筛选项列表(点击)
    sendChangeFilter() {
      const queryList = this.getChangeFilter()
      this.$emit('change', queryList)
    },
    // emit 筛选项列表(点击)
    sendUpdateFilter() {
      const queryList = this.getChangeFilter()
      this.$emit('update', queryList)
    },
    // 更新路由参数
    updateHistoryParams() {
      const urlList = []
      const list = this.getSeletedFilter()
      list.forEach((item) => {
        urlList.push({ [item.type]: item.keysList.join('_') })
      })
      const specialList = this.urlSpecialParams.map((item) => ({ [item.type]: item.value }))
      if (!urlList.length && !specialList.length) {
        window.history.replaceState({}, '', '/courses/list')
      } else {
        resetUrlParams(Object.assign({}, ...urlList, ...specialList), false)
      }
    },
    // 重置所有筛选项
    handleAllReset() {
      this.filtersData.forEach((item, index) => {
        item.dataList.forEach((item1, index1) => {
          this.filtersData[index].dataList[index1].selected = false
          if (item.filterType === 'difficulty') this.changeRateColor(item1, index1, index)
        })
        this.filtersData[index].dataList[0].selected = true
      })
      this.updateHistoryParams()
      this.sendChangeFilter()
      this.handleResetTrack()
    },
    // 点击展开/收起按钮埋点上报
    handleMoreTrack(isMore) {
      this.Sensors.track('courses_list_stretch_click', {
        type: isMore ? 'open' : 'retract',
      })
    },
    // 点击重置按钮埋点上报
    handleResetTrack() {
      this.Sensors.track('courses_list_reset_click')
    },
  },
}
